'use client';

import { useTranslations } from 'next-intl';
import styles from './TrustBadges.module.css';

const TRUST_ITEMS_EN = [
  {
    icon: '🎁',
    title: 'Free Shipping',
    description: 'On orders over €50 across Europe',
  },
  {
    icon: '↩️',
    title: 'Easy Returns',
    description: '30-day money back guarantee',
  },
  {
    icon: '🔒',
    title: 'Secure Shopping',
    description: '100% secure payment processing',
  },
  {
    icon: '👍',
    title: 'Authentic Products',
    description: 'All products verified and genuine',
  },
];

const TRUST_ITEMS_ES = [
  {
    icon: '🎁',
    title: 'Envío Gratis',
    description: 'En pedidos superiores a €50 en toda Europa',
  },
  {
    icon: '↩️',
    title: 'Devoluciones Fáciles',
    description: 'Garantía de devolución de dinero en 30 días',
  },
  {
    icon: '🔒',
    title: 'Compra Segura',
    description: 'Procesamiento de pagos 100% seguro',
  },
  {
    icon: '👍',
    title: 'Productos Auténticos',
    description: 'Todos los productos verificados y genuinos',
  },
];

const TRUST_ITEMS_DE = [
  {
    icon: '🎁',
    title: 'Kostenloser Versand',
    description: 'Bei Bestellungen über €50 in ganz Europa',
  },
  {
    icon: '↩️',
    title: 'Einfache Rücksendungen',
    description: '30 Tage Geld-zurück-Garantie',
  },
  {
    icon: '🔒',
    title: 'Sicheres Einkaufen',
    description: '100% sichere Zahlungsabwicklung',
  },
  {
    icon: '👍',
    title: 'Authentische Produkte',
    description: 'Alle Produkte verifiziert und echt',
  },
];

const TRUST_ITEMS_FR = [
  {
    icon: '🎁',
    title: 'Livraison Gratuite',
    description: 'Sur les commandes de plus de €50 en Europe',
  },
  {
    icon: '↩️',
    title: 'Retours Faciles',
    description: 'Garantie de remboursement en 30 jours',
  },
  {
    icon: '🔒',
    title: 'Achat Sécurisé',
    description: 'Traitement des paiements 100% sécurisé',
  },
  {
    icon: '👍',
    title: 'Produits Authentiques',
    description: 'Tous les produits vérifiés et authentiques',
  },
];

const TRUST_ITEMS_MAP = {
  en: TRUST_ITEMS_EN,
  es: TRUST_ITEMS_ES,
  de: TRUST_ITEMS_DE,
  fr: TRUST_ITEMS_FR,
};

export default function TrustBadges({ locale = 'en' }) {
  const t = useTranslations('trust');
  const TRUST_ITEMS = TRUST_ITEMS_MAP[locale] || TRUST_ITEMS_EN || [];
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        {(TRUST_ITEMS || []).map((item, index) => (
          <div key={index} className={styles.item}>
            <div className={styles.icon}>{item.icon}</div>
            <h3 className={styles.title}>{item.title}</h3>
            <p className={styles.description}>{item.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
